<app-scoreboard
  [match]="teams"
  [events]="events"
  [live]="live">
</app-scoreboard>
<app-map
  [teams]="teams"
  [events]="events"
  [stats]="stats">
</app-map>
<div class="logo-wrapper">
  <button *ngIf="hasStarted()" #scrollStatsButton class="stats-scroll tooltip" (click)="scrollToStats()"
    attr.data-tooltip="{{ 'Show game stats' | translate }}">
    <img src="/assets/img/icons/color/arrow-scroll.svg" alt="{{ 'Show game stats' | translate}}">
  </button>
  <div class="logos">
    <div class="logo">
      powered by <img src="/assets/img/icons/color/logo_carto.svg" alt="carto">
    </div>
    <!-- <a class="logo geo">
      engineered by <img src="/assets/img/icons/color/GEO_alt.svg" alt="Geographica">
    </a> -->
  </div>
</div>
<div id="div-banner_inferior" class="banner"></div>
<app-stats
  *ngIf="hasStarted()"
  [match]="teams"
  [events]="events"
  [stats]="stats">
</app-stats>
<div class="loader-overlay" *ngIf="loading" [class.show]="loading">
  <p>Cargando visualización</p>
</div>
